import { PlanModel } from "../models/plan.model";

export class Plan {

    constructor(private plan: PlanModel) {}

    get data(): PlanModel {
        return this.plan;
    }

    get id(): number {
        return this.plan.id;
    }

    get tokensPerMonth(): number {
        return this.plan.token_per_month;
    }

    get name(): string {
        return this.plan.name;
    }

    get userId(): number {
        return this.plan.user;
    }

    get startDate(): Date {
        return this.plan.start_date;
    }

    get endDate(): Date | null {
        return this.plan.end_date;
    }

    get cancelDate(): Date | null {
        return this.plan.cancel_date;
    }

    get stripeProductId(): string | null {
        return this.plan.stripe_product_id;
    }

    get stripeSubscriptionId(): string | null {
        return this.plan.stripe_subscription_id;
    }

    get createdAt(): Date {
        return this.plan.created_at;
    }

    get updatedAt(): Date | null {
        return this.plan.updated_at;
    }

    get deletedAt(): Date | null {
        return this.plan.deleted_at;
    }

    /** Retourne true si le plan est encore actif */
    get isActive(): boolean {
        const now = new Date();
        return (
            (!this.cancelDate || this.cancelDate > now) &&
            (!this.endDate || this.endDate > now) &&
            !this.deletedAt
        );
    }

    /** Retourne true si le plan a été annulé */
    get isCanceled(): boolean {
        return !!this.cancelDate;
    }

    /** Retourne true si le plan est terminé */
    get isExpired(): boolean {
        return this.endDate !== null && this.endDate < new Date();
    }

    /** Retourne true si le plan est supprimé (soft delete) */
    get isDeleted(): boolean {
        return !!this.deletedAt;
    }
}
